'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('./compose');

var TOGGLE_I_OWN_THIS_EVENT = 'bc.toggleIOwnThis';
var TOGGLE_I_OWN_THIS_ACTION = 'v2-toggle-i-own-this';
var I_OWN_THIS_GTM_CATEGORY = 'v2-shelves';

function composeIOwnThisEvent(iOwnThisStatus) {
  return (0, _compose.composeEvent)(TOGGLE_I_OWN_THIS_EVENT, {
    gtmValue: 1,
    gtmLabel: iOwnThisStatus,
    gtmCategory: I_OWN_THIS_GTM_CATEGORY,
    gtmAction: TOGGLE_I_OWN_THIS_ACTION
  });
}

function composeToggleIOwnThisEvent(iOwnThisStatus) {
  // conversion made because gtmLabel is expecting a string
  var status = iOwnThisStatus ? 'true' : 'false';
  return (0, _compose.composeAnalytics)([composeIOwnThisEvent(status)]);
}

exports.default = {
  composeToggleIOwnThisEvent: composeToggleIOwnThisEvent,
  TOGGLE_I_OWN_THIS_EVENT: TOGGLE_I_OWN_THIS_EVENT,
  TOGGLE_I_OWN_THIS_ACTION: TOGGLE_I_OWN_THIS_ACTION,
  I_OWN_THIS_GTM_CATEGORY: I_OWN_THIS_GTM_CATEGORY
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/iOwnThisEventComposer.js
// module id = 994
// module chunks = 1